import React from "react";
import { useStaticQuery, graphql, Link } from "gatsby";
import Frame from "~/views/layout/frame";

const NotFoundPage = () => {

  return (
    <Frame>
      <div>404</div>
    </Frame>
  );
};

export default NotFoundPage;
